var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5809_14634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2511 4.58289H12.9178C11.8348 4.58289 10.7962 5.01309 10.0305 5.77887C9.26468 6.54464 8.83447 7.58325 8.83447 8.66622V41.3329C8.83447 42.4159 9.26468 43.4545 10.0305 44.2202C10.7962 44.986 11.8348 45.4162 12.9178 45.4162H37.4178C38.5008 45.4162 39.5394 44.986 40.3052 44.2202C41.0709 43.4545 41.5011 42.4159 41.5011 41.3329V16.8329L29.2511 4.58289Z",
    stroke: "#B90000",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2524 4.58289V16.8329H41.5024",
    stroke: "#B90000",
    strokeWidth: 3.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.668457,
    y: 22.5,
    width: 29,
    height: 13,
    rx: 1,
    fill: "#B90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4485 27.68C11.4485 28.0533 11.3585 28.4033 11.1785 28.73C11.0051 29.0567 10.7285 29.32 10.3485 29.52C9.97512 29.72 9.50179 29.82 8.92846 29.82H7.75846V32.5H6.35846V25.52H8.92846C9.46846 25.52 9.92846 25.6133 10.3085 25.8C10.6885 25.9867 10.9718 26.2433 11.1585 26.57C11.3518 26.8967 11.4485 27.2667 11.4485 27.68ZM8.86846 28.69C9.25512 28.69 9.54179 28.6033 9.72846 28.43C9.91512 28.25 10.0085 28 10.0085 27.68C10.0085 27 9.62846 26.66 8.86846 26.66H7.75846V28.69H8.86846ZM14.8824 25.52C15.6158 25.52 16.2591 25.6633 16.8124 25.95C17.3724 26.2367 17.8024 26.6467 18.1024 27.18C18.4091 27.7067 18.5624 28.32 18.5624 29.02C18.5624 29.72 18.4091 30.3333 18.1024 30.86C17.8024 31.38 17.3724 31.7833 16.8124 32.07C16.2591 32.3567 15.6158 32.5 14.8824 32.5H12.4424V25.52H14.8824ZM14.8324 31.31C15.5658 31.31 16.1324 31.11 16.5324 30.71C16.9324 30.31 17.1324 29.7467 17.1324 29.02C17.1324 28.2933 16.9324 27.7267 16.5324 27.32C16.1324 26.9067 15.5658 26.7 14.8324 26.7H13.8424V31.31H14.8324ZM23.9204 25.52V26.65H21.0104V28.44H23.2404V29.55H21.0104V32.5H19.6104V25.52H23.9204Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5809_14634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(0.668457 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.07709a8b6ce9c6fd77fb11db25a727ab.svg";
export { ForwardRef as ReactComponent };